import {
  IconArchive,
  IconBriefcase,
  IconBuilding,
  IconBuildingCommunity,
  IconBuildingCottage,
  IconBuildingEstate,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconCar,
  IconHome,
  IconHome2,
  IconProps,
} from '@tabler/icons-react';
import * as React from 'react';

export const PLACE_TYPE_ICON_BY_NAME: Record<string, React.FC<IconProps>> = {
  Квартира: IconHome,
  Апартаменты: IconBuildingEstate,
  Офис: IconBriefcase,
  'Торговое помещение': IconBuildingStore,
  'Помещение свободного назначения': IconBuilding,
  Машиноместо: IconCar,
  Кладовка: IconArchive,
  Склад: IconBuildingWarehouse,
  Таунхаус: IconBuildingCommunity,
  Коттедж: IconBuildingCottage,
  Вилла: IconBuildingCottage,
  Пентхаус: IconBuildingSkyscraper,
  Дуплекс: IconHome2,
};

export const PLACE_TYPE_ICON_SIZE = 16;

export const normalizePlaceTypeName = (name: string): string => name.toLowerCase().replace(/[\s-]+/g, '');

const placeTypeIconByNormalizedName = new Map(
  Object.entries(PLACE_TYPE_ICON_BY_NAME).map(([name, icon]) => [normalizePlaceTypeName(name), icon]),
);

export const getPlaceTypeIcon = (name: string): React.FC<IconProps> | null =>
  placeTypeIconByNormalizedName.get(normalizePlaceTypeName(name)) ?? null;
